var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16449_1427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 21,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9316 1H1.5V23.9856H21.9316V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16449_1427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7199 7.32901C8.81933 7.32901 6.47973 9.63202 6.47973 12.4873C6.47973 15.3425 8.81933 17.6456 11.7199 17.6456C14.6204 17.6456 16.9601 15.3425 16.9601 12.4873C16.9601 9.63202 14.6204 7.32901 11.7199 7.32901ZM11.7199 15.8408C9.84553 15.8408 8.3131 14.3369 8.3131 12.4873C8.3131 10.6376 9.84094 9.13375 11.7199 9.13375C13.5988 9.13375 15.1267 10.6376 15.1267 12.4873C15.1267 14.3369 13.5944 15.8408 11.7199 15.8408ZM18.3967 7.118C18.3967 7.78692 17.8494 8.32116 17.1744 8.32116C16.4949 8.32116 15.9522 7.78244 15.9522 7.118C15.9522 6.45358 16.4995 5.91486 17.1744 5.91486C17.8494 5.91486 18.3967 6.45358 18.3967 7.118ZM21.8673 8.33911C21.7897 6.72742 21.4158 5.29981 20.2164 4.12359C19.0215 2.94738 17.5711 2.57925 15.9339 2.49844C14.2465 2.40416 9.18879 2.40416 7.50131 2.49844C5.86861 2.57476 4.41832 2.94288 3.21888 4.11911C2.01942 5.29532 1.65002 6.72294 1.56792 8.33463C1.47215 9.99571 1.47215 14.9744 1.56792 16.6355C1.64546 18.2472 2.01942 19.6748 3.21888 20.851C4.41832 22.0273 5.86405 22.3953 7.50131 22.4761C9.18879 22.5704 14.2465 22.5704 15.9339 22.4761C17.5711 22.3999 19.0215 22.0317 20.2164 20.851C21.4112 19.6748 21.7851 18.2472 21.8673 16.6355C21.963 14.9744 21.963 10.0002 21.8673 8.33911ZM19.6873 18.4178C19.3316 19.2977 18.6429 19.9755 17.7445 20.3303C16.3991 20.8555 13.2067 20.7343 11.7199 20.7343C10.2331 20.7343 7.03612 20.851 5.69529 20.3303C4.80141 19.98 4.11276 19.3022 3.75247 18.4178C3.21888 17.0934 3.34202 13.9509 3.34202 12.4873C3.34202 11.0238 3.22344 7.8767 3.75247 6.55683C4.1082 5.67692 4.79685 4.99902 5.69529 4.64435C7.04068 4.11911 10.2331 4.24032 11.7199 4.24032C13.2067 4.24032 16.4037 4.12359 17.7445 4.64435C18.6384 4.99453 19.327 5.67242 19.6873 6.55683C20.2208 7.8812 20.0977 11.0238 20.0977 12.4873C20.0977 13.9509 20.2208 17.0979 19.6873 18.4178Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.f4f35935223b9cb74e6529ac517a4140.svg";
export { ForwardRef as ReactComponent };